import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EnvironmentConfig } from '../../../shared/interfaces/environment.interface';
import { Reconcilation } from '../../interfaces/adjustments-reconciliation-service.interface';

@Injectable({
  providedIn: 'root',
})
export class ManageReconciliationService {
  private readonly _rmfUrl = this._env.environment.pureSpectrum.rmfUrl;
  private readonly _baseUrl = this._env.environment.pureSpectrum.url;

  constructor(
    private _http: HttpClient,
    @Inject('ENV') private _env: EnvironmentConfig
  ) {}

  getAdjustmentsFilesDataForSurvey(surveyId: number | undefined) {
    return this._http.get<Reconcilation[]>(
      `${this._rmfUrl}/v2/rmf/adjustments/surveys/${surveyId}`
    );
  }
}
